import ApiService from "./ApiService";
import { BASE_URL } from "constants/api.constant";

export async function apiGetMrTargetData(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}get-mr-targets?mr_id=${data.mr_id}&target_duration_type=${data.target_duration_type}`,
    method: "get",
  });
}

export async function apiSetMrTarget(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}create-mr-target`,
    method: "post",
    data,
  });
}

export async function apiSetMrTargetStatus(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}update-target-statuses`,
    method: "post",
    data,
  });
}

export async function apiGetTrackingReport(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}mr-activity-report`,
    method: "post",
    data,
    responseType: data.download ? 'blob' : 'json'
  });
}

export async function apiGetWhatsappNotifications() {
  return ApiService.fetchData({
    url: `${BASE_URL}wa-notification-preferences`,
    method: "get"
  });
}

export async function apiSetWhatsappNotifications(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}wa-notification-preferences-update`,
    method: "post",
    data
  });
}

export async function apiGetMrTargetReportData(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}mr-target-report`,
    method: "post",
    data,
    responseType: data.download ? 'blob' : 'json'
  });
}
